import { z } from "zod";
import { Sha256Schema } from "./projectLedger.js";
import { IdSchema, IsoTimestampSchema, NonEmptyStringSchema } from "./source.js";
export const PROJECT_EXPORT_MODES = ["internal_draft", "client_issue"];
export const ProjectExportModeSchema = z.enum(PROJECT_EXPORT_MODES);
export const PROJECT_ISSUE_PROFILES = ["priced", "technical_only"];
export const ProjectIssueProfileSchema = z.enum(PROJECT_ISSUE_PROFILES);
export const ProjectExportArtifactV1Schema = z
    .object({
    path: NonEmptyStringSchema,
    contentType: NonEmptyStringSchema,
    byteLength: z.number().int().positive(),
    sha256: Sha256Schema
})
    .strict();
export const ProjectExportEventV1Schema = z
    .object({
    schemaVersion: z.literal(1),
    id: IdSchema,
    orgId: IdSchema,
    projectId: IdSchema,
    mode: ProjectExportModeSchema,
    issueProfile: ProjectIssueProfileSchema,
    readinessRevision: z.number().int().positive(),
    sourceVersionHash: Sha256Schema,
    projectRevision: NonEmptyStringSchema,
    specResultId: IdSchema.nullable(),
    ledgerRevision: z.number().int().nonnegative(),
    catalogueRelease: NonEmptyStringSchema.nullable(),
    artifacts: z.array(ProjectExportArtifactV1Schema).min(1),
    watermark: z.literal("DRAFT — NOT FOR ISSUE").nullable(),
    createdAt: IsoTimestampSchema,
    createdBy: NonEmptyStringSchema,
    idempotencyKey: NonEmptyStringSchema
})
    .strict()
    .superRefine((event, context) => {
    const paths = event.artifacts.map((artifact) => artifact.path);
    if (new Set(paths).size !== paths.length) {
        context.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["artifacts"],
            message: "Export artifact paths must be unique."
        });
    }
    if ((event.mode === "internal_draft") !==
        (event.watermark === "DRAFT — NOT FOR ISSUE")) {
        context.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["watermark"],
            message: "Internal drafts require the pinned draft watermark only."
        });
    }
});
//# sourceMappingURL=projectExport.js.map